import React from "react";
import ImageGallery from 'react-image-gallery';
import File from "./File";
import * as agent from "../agent";
import Grid from '@material-ui/core/Grid';
import PrintLink from './PrintLink';
import "react-image-gallery/styles/css/image-gallery.css";

export const Files = ({ isJur, isBroker = false, status, tradeStatus }) => {
    return (
    <Grid container justify="flex-start" spacing={16}>
        <Grid item>
              <File name="car"
                    desc="Фотографии ТС"
                    title="Фотографии автомобиля" />
        </Grid>
        <Grid item>
              <File name="licence"
                    desc="Копия ПТС с 2-х сторон"
                    title="Копия ПТС с 2-х сторон" />
        </Grid>
        <Grid item>
              <File name="registrationCertificate"
                    desc="Копия СТС с 2-х сторон"
                    title="Копия СТС с 2-х сторон" />
        </Grid>
        <Grid item>
              <File name="passport"
                    desc="Копия паспорта"
                    title="Копия паспорта" />
        </Grid>
        <Grid item>
              <File name="acceptConditions"
                    desc="Согласие на обработку"
                    title="Согласие на обработку"/>
        </Grid>
    {isJur &&
        <React.Fragment>
            <Grid item>
                <File name="statuteScan"
                      desc="Скан-копия Устава"
                      title="скан-копия устава организации" />
            </Grid>
            <Grid item>
                <File name="INN"
                      desc="Копии ИНН, ОГРН"
                      title="Копии ИНН, ОГРН" />
            </Grid>
            <Grid item>
                <File name="order"
                      desc="Приказ о назначении руководителя"
                      title="Копия приказа" />
            </Grid>
        </React.Fragment>
    }
    {!isBroker &&
        <React.Fragment>
            <Grid item>
                <File name="securityAttach"
                      desc="Результат СБ"
                      title="результат СБ" />
            </Grid>
            <Grid item>
                <File name="contractScan"
                    desc="Скан-копия Договора"
                    title="Скан-копии документов" />
            </Grid>
            <Grid item>
                <File name="depositScan"
                    desc="Документ о залоге"
                    title="Скан-копии документов" />
            </Grid>
            {(status === "TRADE" || (status === "CLOSED" && tradeStatus === "SECOND")) &&
                <Grid item>
                    <File name="purchaserPassport"
                          desc="Скан-копия паспорта Покупателя"
                          title="Скан-копия паспорта Покупателя" />
                </Grid>
            }
        </React.Fragment>
    }
    </Grid>
)};

class Gallery extends React.Component {
    state = {
        value: 0
    };

    switchTab = (e, value) => this.setState({ value });

    change(e) {
        this.setState({subComponentToggle: e.target.checked});
    }

    render() {
        const { car, isJur } = this.props;
        const { docs, loan: {status} = {}, trade: {status: tradeStatus} = {} } = car;
        const hasImages = Object.keys(docs).some(doc => docs[doc].length > 0);

        const files = Object.keys(docs).reduce((acc, item) => acc.concat(docs[item]
            .filter(doc => doc.contenttype.startsWith("image"))
            .map(doc => ({ original: agent.src.doc(doc.id), thumbnail: agent.src.thumb(doc.thumb) }) )
        ), []);

        return (
            <div className="image-gallery">
                <Files isJur={isJur} tradeStatus={tradeStatus} status={status}/>
                { hasImages && <div className="m20"><PrintLink href={agent.src.zip(car._id)} label="Скачать архивом" /></div> }
                { hasImages && <ImageGallery lazyLoad={true} showPlayButton={false} items={files} /> }
            </div>
        );
    }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.js